import {TAB_SHOW} from '../../../common/tabs/tabs.constants';
import {TYPES as ACTION_TYPES} from './master-doc-list-action-type.constants';
import {TYPES as ACC_TYPES} from "../accreditation-action-type.constants";
import {IDS} from './master-doc-list-action-id.constants';
import * as Actions from './master-doc-list.actions';
import * as AccreditationActions from '../accreditation.actions';
import * as RequirementsActions from '../settings/requirements/requirements.actions';
import get from "lodash/get";
import {GRID_FILTER, GRID_FILTER_TOGGLE, GRID_RELOAD} from '../../../common/grid/grid.constants';

class MasterDocListController {
    constructor($ngRedux, $uiRouterGlobals, $state, $stateParams, $scope, $rootScope, $filter, NavigationService, AuthService, EmployeeService, DocumentManager, $timeout) {
        this.$ngRedux = $ngRedux;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.NavigationService = NavigationService;
        this.AuthService = AuthService;
        this.EmployeeService = EmployeeService;
        this.DocumentManager = DocumentManager;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.identifier = IDS.masterDocList;
        const navConfig = this.NavigationService.getConfig(this.$state.$current);
        this.colorName = navConfig.colorName;
        this.icon = navConfig.iconSvg.replace(/(\.\/)/g, '');

        this.unsubscribe = this.$ngRedux.connect(state => {
            const selectedRequirement = state.accreditation.masterDocList.selectedRequirement;
            return {
                schemeId:      state.accreditation.masterDocList.frameworkDetails.id,
                sectionsTree:  state.accreditation.simpleSectionsTree,

                selectedRequirementSchemeCode:  selectedRequirement?.schemeCode,
                requirementId:                  selectedRequirement?.id,
                requirementParentId:            selectedRequirement?.requirementParentId,
            };
        }, {...AccreditationActions, ...RequirementsActions, ...Actions})(this);

        const {itemCode, year, hof, slo, doc} = this.$stateParams;
        this.schemeCode = itemCode;

        const ctrl = this;

        var user = this.AuthService.getUser();
        if(user.parentCount !== 1){
            this.fetchFrameworkRequirementsTree(this.schemeCode).then(()=>{
                ctrl.initSectionsInputSelects({});
            })
        }
        else{
            this.EmployeeService.getEmploymentLocations(user.uuid).then(siteLocations => {
                const firstSiteLocation = get(siteLocations,'[0].uuid');
                this.$stateParams.slo = firstSiteLocation;
                this.$ngRedux.dispatch({
                    type: ACC_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        siteLocation: firstSiteLocation,
                    }
                });
                this.fetchFrameworkRequirementsTree(this.schemeCode, firstSiteLocation).then(()=> {
                    ctrl.initSectionsInputSelects({});
                })
            });
        }

        this.getRegulatoryFrameworkDetails(this.schemeCode).then(scheme => {
            this.$ngRedux.dispatch({
                type:   ACTION_TYPES.SCHEME_DETAILS_REFRESH,
                id:     IDS.masterDocList,
                data: {
                    ...scheme,
                }
            });
            this.schemeName = scheme.name;

            if(doc){
                this.fetchMasterDocListDocumentDetails({
                    vdo_uuid: doc,
                    slo_uuid: slo,
                    framework_code: this.schemeCode
                }).then( data => {
                    this.$ngRedux.dispatch({
                        type:   ACTION_TYPES.DOC_DETAILS_REFRESH,
                        id:     IDS.masterDocList,
                        data: {
                            ...data,
                            id: doc,
                            fiscal_year: year,
                        },
                    });
                    this.$ngRedux.dispatch({
                        type: TAB_SHOW,
                        id: IDS.app_accreditation_scheme_master_doc_list,
                        state: IDS.app_accreditation_scheme_master_doc_list_details,
                    });
                    this.$timeout(()=> {
                        this.$ngRedux.dispatch({
                            type: GRID_FILTER,
                            id: IDS.masterDocList,
                            path: IDS.masterDocListRequirementsGrid,
                            filter: {
                                framework_code: this.schemeCode,
                                vdo_uuid: doc,
                                slo_uuid: slo,
                                // audit_cycle_id: item.audit_cycle_id,
                            },
                        });
                    },200);
                });
            }
        })
    }

    initSectionsInputSelects({deselectAll}) {
        // insert requirements to first requirement select box
        this.$ngRedux.dispatch({
            type: ACTION_TYPES.SELECT_REQUIREMENTS_SELECT_CASCADE,
            id: IDS.masterDocList,
            level:0,
            sections: this.sectionsTree,
            requirementId: null,
            requirementParentId: null,
        });

        let requirementLevel1Id, requirementLevel2Id, requirementLevel3Id;
        if(this.requirementId && this.requirementParentId && this.selectedRequirementSchemeCode === this.schemeCode){
            const requirement = this.findChildRequirementById(this.requirementParentId, this.sectionsTree);
            requirementLevel1Id = requirement.requirementParentId;
            requirementLevel2Id = this.requirementParentId;
            requirementLevel3Id = this.requirementId;
        }
        else{
            requirementLevel1Id = get(this.sectionsTree,'[0].id');
            requirementLevel2Id = get(this.sectionsTree,'[0].children[0].id');
            requirementLevel3Id = get(this.sectionsTree,'[0].children[0].children[0].id');
        }

        if(requirementLevel1Id) this.onSelectRequirement({item:{value: requirementLevel1Id}, skipGridFetch: true, deselectAll});
        if(requirementLevel2Id) this.onSelectRequirement({item:{value: requirementLevel2Id}, skipGridFetch: !!requirementLevel3Id, deselectAll});
        let level3Requirement;
        if(requirementLevel3Id)
            level3Requirement = this.onSelectRequirement({item:{value: requirementLevel3Id}, skipGridFetch: !!deselectAll, deselectAll});

        if(level3Requirement && deselectAll === false){
            this.getFrameworkselectedRequirement({
                ...level3Requirement,
                schemeCode: this.schemeCode
            });
        }
        if(deselectAll)
            this.$ngRedux.dispatch({
                type:   ACTION_TYPES.RESET_REQUIREMENTS_SELECT_CASCADE,
                id:     IDS.masterDocList,
            });
    }

    onSelectRequirement({item, skipGridFetch = undefined, deselectAll = false}){
        if(!item) // selecting 3rd level requirement when no requirement 3rd level requirement exist
            return;
        const requirement = this.findChildRequirementById(item.value, this.sectionsTree);
        const level3Requirements = requirement.level === 1 && requirement.children.length
            ? this.findChildRequirementById(requirement.children[0].id, this.sectionsTree).children
            : undefined;
        this.$ngRedux.dispatch({
            type:       ACTION_TYPES.SELECT_REQUIREMENTS_SELECT_CASCADE,
            id:         IDS.masterDocList,
            sectionId:  requirement.id,
            level:      requirement.level,
            sections:   requirement.children,
            level3Requirements,
            schemeCode: this.schemeCode
        });

        const level3Requirement =
            level3Requirements?.length && level3Requirements[0]
            || requirement.children?.length && requirement.children[0]
            || requirement;

        if(deselectAll === false) {
            this.$ngRedux.dispatch({
                type: ACTION_TYPES.REQUIREMENT_DETAILS_REFRESH,
                id: this.identifier,
                data: {
                    id: level3Requirement.id,
                    requirementParentId: level3Requirement.requirementParentId,
                    level: level3Requirement.level,
                    nodeName: level3Requirement.name,
                    prefix: level3Requirement.number,
                    siblings: level3Requirement.children.map(item => parseInt(item.numberRaw.split('.').pop())),
                    schemeCode: level3Requirement.schemeCode,
                }
            });
        }

        this.$ngRedux.dispatch({
            type: skipGridFetch ? GRID_FILTER_TOGGLE : GRID_FILTER,
            id: IDS.masterDocList,
            path: IDS.masterDocListGrid,
            filter: {
                requirement_id: level3Requirement.id,
                framework_code: this.schemeCode
            }
        });
        return level3Requirement
    }

    findChildRequirementById(id, requirements) {
        return requirements.reduce((result, item) => {
            if(result)
                return result;
            if(item.id === id)
                return item
            else if (item.children.length)
                return this.findChildRequirementById(id, item.children)
        }, null);
    }

    // onGridFilterChange(event) {
    //     this.$ngRedux.dispatch({
    //         type: GRID_RELOAD,
    //         id: IDS.masterDocList,
    //         path: IDS.masterDocListGrid,
    //         filter: {
    //         }
    //     });
    // }

    onResetGridFilterButton(){
        this.initSectionsInputSelects({deselectAll: true});

        this.$ngRedux.dispatch({
          type: GRID_FILTER,
          id: IDS.masterDocList,
          path: IDS.masterDocListGrid,
          filter: {
            loc_uuid: null,
            requirement_id: null,
            keyword: null,
            searched_column: "name",
            doc_type: "all",
            due_date_to: null,
            due_date_from: null,
          },
        });

        this.$rootScope.$broadcast('SELECT_CASCADE_RESET', 'masterDocListSelectCascadeForm');
    }

    onSelectDocument({item}) {
        this.$ngRedux.dispatch({
            type:   ACTION_TYPES.DOC_DETAILS_REFRESH,
            id:     IDS.masterDocList,
            data:  {
                ...item,
                schemeId: this.schemeId,
                requirementsRaw: JSON.parse(item.requirementsRaw),
            }
        });
        this.$ngRedux.dispatch({
            type: TAB_SHOW,
            id: IDS.app_accreditation_scheme_master_doc_list,
            state: IDS.app_accreditation_scheme_master_doc_list_details,
        });
        this.$timeout(()=> {
            this.$ngRedux.dispatch({
              type: GRID_FILTER,
              id: IDS.masterDocList,
              path: IDS.masterDocListRequirementsGrid,
              filter: {
                framework_code: this.schemeCode,
                vdo_uuid: item.id,
                slo_uuid: item.slo_uuid,
                audit_cycle_id: item.audit_cycle_id,
              },
            });
        },200);
    };

    onDownloadButton({item}){
        this.DocumentManager.downloadFile(item.doc_uri);
    }

    $onDestroy() {
        this.unsubscribe();
    }
}

MasterDocListController.$inject = ['$ngRedux', '$uiRouterGlobals', '$state', '$stateParams', '$scope', '$rootScope', '$filter', 'NavigationService', 'AuthService','EmployeeService', 'DocumentManager', '$timeout'];

export const masterDocList = {
  controller: MasterDocListController,
  template: `
        <tabs-header title="{{$ctrl.schemeName}}" icon="{{$ctrl.icon}}" color-name="{{$ctrl.colorName}}"></tabs-header>
        <form name="masterDocListSelectCascadeForm" novalidate layout="row" style="margin: 20px">
            <div layout="column" flex>
                <div layout-gt-xs="row" flex>
                    <input-select flex label="Level 1"
                                  identifier="{{$ctrl.identifier}}"
                                  state-path="requirementsSelectCascade.level1RequirementId"
                                  state-data="requirementsSelectCascade.level1Requirements"
                                  on-change="$ctrl.onSelectRequirement($event)"
                                  select-first-item="true">
                    </input-select>
                    <input-select flex label="Level 2"
                                  identifier="{{$ctrl.identifier}}"
                                  state-path="requirementsSelectCascade.level2RequirementId"
                                  state-data="requirementsSelectCascade.level2Requirements"
                                  on-change="$ctrl.onSelectRequirement($event)"
                                  select-first-item="true">
                    </input-select>
                    <input-select flex label="Level 3"
                                  identifier="{{$ctrl.identifier}}"
                                  state-path="requirementsSelectCascade.level3RequirementId"
                                  state-data="requirementsSelectCascade.level3Requirements"
                                  on-change="$ctrl.onSelectRequirement($event)"
                                  select-first-item="true">
                    </input-select>
                </div>
                <div layout-gt-xs="row">
                    <input-select flex-gt-xs="35"
                                    label="{{'COMMON.DOCUMENT.TYPE' | translate}}"
                                    identifier="{{$ctrl.identifier}}"
                                    state-data="gridFilterDocumentTypes"
                                    state-path="masterDocListGrid.filter.doc_type">
                    </input-select>
                    <input-text-area flex-gt-md="60"
                                     rows="1"
                                     max-length="45"
                                     label="{{'COMMON.FIELD.KEYWORD' | translate}}"
                                     identifier="{{$ctrl.identifier}}"
                                     name="request"
                                     state-path="masterDocListGrid.filter.keyword"
                                     max-length="45">
                    </input-text-area>
            
                    <input-select flex-gt-xs="35" label="Search text in"
                                  identifier="{{$ctrl.identifier}}"
                                  state-path="masterDocListGrid.filter.searched_column"
                                  state-data="searchedColumns">
                    </input-select>
                </div>
                <div layout-gt-xs="row" layout-align="start center" flex>
                    <input-select flex-gt-xs="33"
                                    label="Assessment Status"
                                    identifier="{{$ctrl.identifier}}"
                                    state-path="masterDocListGrid.filter.assessment_status"
                                    state-data="assessmentStatuses">
                    </input-select>
                    <div layout-gt-xs="row"  flex>
                        <select-cascade flex 
                            identifier="{{$ctrl.identifier}}"
                            state-path="masterDocListGrid" 
                            purpose="'aeq'" 
                            validate="true"
                            max="slo">
                        </select-cascade>
                    </div>
                </div>
                <div layout-gt-xs="row" layout-align="center center" flex>
                    <div layout-gt-xs="row"  flex>
<!--                        <input-date name="dueDateFrom"-->
<!--                                    label="Due Date From"-->
<!--                                    identifier="{{$ctrl.identifier}}"-->
<!--                                    state-path="masterDocListGrid.filter.due_date_from">-->
<!--                        </input-date>-->
<!--                        <input-date name="dueDateTo"-->
<!--                                    label="Due Date To"-->
<!--                                    identifier="{{$ctrl.identifier}}"-->
<!--                                    state-path="masterDocListGrid.filter.due_date_to">-->
<!--                        </input-date>-->
                    </div>
                    <div layout-="100px">
                        <button class="btnDefault" ng-click="$ctrl.onResetGridFilterButton()">{{'COMMON.BUTTON.RESET_FILTER' | translate}}</button>
                    </div>
                </div>
            </div>
            
        </form>
        <master-doc-list-grid
                on-select="$ctrl.onSelectDocument($event)"
                on-download="$ctrl.onDownloadButton($event)">
        </master-doc-list-grid>
`,
};
